import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils/utils';
import { useTranslation } from 'react-i18next';

export function SubmitButton({ isSubmitting = false, children, loadingText, type = 'submit', className, ...props }) {
    const { t } = useTranslation();
    return (
        <Button
            variant="solid"
            color="success"
            type={type}
            disabled={isSubmitting}
            className={cn('submit-button', className)}
            {...props}
        >
            {isSubmitting ? (
                <>
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                    {loadingText || t('common:chargement')}
                </>
            ) : (
                children
            )}
        </Button>
    );
}
